<div class="modal-backdrop fade" *ngIf="openSignup" [class.show]="openSignup"></div>
<div class="modal fade" *ngIf="openSignup" [ngClass]="{'show displayBlock' : openSignup}"
    [class.displayBlock]="openSignup">
    <div class="modal-dialog signin-modal">
        <div class="modal-content">
            <div class="card p-0 signin-card">
                <div class="row g-0 h-100">
                    <div class="col-md-5 h-100">
                        <div class="signin-info h-100 d-flex justify-content-around flex-column align-items-center">
                            <h1>Tenders Made Easy <br /> To Search</h1>
                            <h2>Search any tender by Location, Category, Organization, High Value, Low value, Fresh Bid
                            </h2>
                            <img loading="lazy" src="https://d1tiqtcifmy0l7.cloudfront.net/prod/icons/signin-1.svg"
                                alt="">
                        </div>
                    </div>
                    <div class="col-md-7">
                        <button type="button"
                            class="btn-close-1 close pull-right d-flex align-items-center jusity-content-center"
                            aria-label="Close" (click)="closeModal()">
                            <i class="sprite-img-header-footer black-cross-circle"></i>
                        </button>

                        <div
                            class="card-body signin-button-section h-100 d-flex align-items-start justify-content-center jusity-content-center">
                            <div class="text-start w-100" *ngIf="false || !stepTwo">
                                <h5 class="card-title">Almost There</h5>
                                <p class="card-text">You are just 1 step away Please provide information below</p>

                                <form #signupForm="ngForm" (ngSubmit)="signUpModal(signupForm)" novalidate>

                                    <div *ngIf="!verifyData?.businessName">
                                        <!-- Business Name -->
                                        <div class="form-floating mb-3">
                                            <input type="text" [(ngModel)]="businessName" name="businessName"
                                                class="form-control" id="businessName" #businessNameField="ngModel"
                                                required>
                                            <label for="businessName">Business Name*</label>
                                            <div *ngIf="(businessNameField.invalid && (businessNameField.dirty || signupForm.submitted))"
                                                class="input-note error">
                                                Business Name is required.
                                            </div>
                                        </div>

                                        <!-- GST Number -->
                                        <div class="form-floating mb-3">
                                            <input type="text" [(ngModel)]="gstNumber" name="gstNumber"
                                                class="form-control" id="gstNumber" #gstNumberField="ngModel"
                                                maxlength="15" required>
                                            <label for="gstNumber">GST No.*</label>
                                            <div *ngIf="(gstNumberField.invalid && (gstNumberField.dirty || signupForm.submitted))"
                                                class="input-note error">
                                                GST Number is required.
                                            </div>
                                            <div *ngIf="gstNumberField.valid && !isValidGstNumber(gstNumber) && (gstNumberField.dirty || signupForm.submitted)"
                                                class="input-note error">
                                                Invalid GST Number format.
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <!-- Email -->
                                        <div class="form-floating mb-3">
                                            <input type="email" [(ngModel)]="email" name="email" class="form-control"
                                                id="email" #emailField="ngModel">
                                            <label for="email">Email</label>
                                            <div *ngIf="emailField.errors?.required && (emailField.dirty || signupForm.submitted)"
                                                class="input-note error">
                                                Email is required.
                                            </div>
                                            <div *ngIf="emailField.errors?.email && (emailField.dirty || signupForm.submitted)"
                                                class="input-note error">
                                                Invalid email format.
                                            </div>
                                        </div>
                                    </div>
                                    <!-- Error Message -->
                                    <span *ngIf="error" class="input-note error">{{error}}</span>

                                    <!-- Submit Button -->
                                    <div class="d-grid gap-2 mt-3">
                                        <button class="btn red-btn" type="submit"
                                            [disabled]="signupForm.invalid || (email && !isValidEmail(email))">CONTINUE</button>
                                    </div>
                                </form>

                                <div class="note d-flex align-items-center mb-3">
                                    <span class="icon">🔒</span>
                                    <span>Your information is completely safe with us</span>
                                </div>
                            </div>

                            <div *ngIf="stepTwo" class="text-start w-100">
                                <h5 class="card-title">Select Keyword (4)</h5>
                                <p class="card-text">Select relevant keyword to get tenders of your choice</p>

                                <app-search-bar [display]="'signUpSearch'"
                                    (searchSelected)="onSearchValueSelected($event)"></app-search-bar>

                                <ul class="keywords-chips">
                                    <li *ngFor="let item of items; let i = index" [class.active]="item.isActive"
                                        (click)="onToggle(i)"> {{ item.name }}
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16"
                                            height="16" fill="currentColor">
                                            <path
                                                d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM11.0026 16L6.75999 11.7574L8.17421 10.3431L11.0026 13.1716L16.6595 7.51472L18.0737 8.92893L11.0026 16Z">
                                            </path>
                                        </svg>
                                    </li>
                                </ul>
                                <div class="d-grid gap-2 mt-3">
                                    <button class="btn red-btn" (click)="setPreferenceFun()"
                                        type="submit">CONTINUE</button>
                                </div>
                                <div class="note d-flex align-items-center mb-3">
                                    <span class="icon">🔒</span>
                                    <span>Your information is completely safe with us</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>